module.exports = __webpack_public_path__ + "img/panicmintz.9c6c1a97.png";